document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-create-bundle]").forEach((root) => {
    const jsonScript = root.querySelector("[data-create-bundle-json]");
    if (!jsonScript) return;

    let data = null;
    try {
      data = JSON.parse(jsonScript.textContent || "{}");
    } catch (error) {
      console.error("Create bundle JSON parse failed", error);
      return;
    }

    const designGroups = data.designGroups || [];
    const globalProducts = data.globalProducts || [];

    const sizeSlider = root.querySelector("[data-create-bundle-size-slider]");
    const sizeValueEl = root.querySelector("[data-create-bundle-size-value]");
    const discountBadgeEl = root.querySelector("[data-create-bundle-discount-badge]");
    const slotsMount = root.querySelector("[data-create-bundle-slots]");
    const tierCards = root.querySelectorAll(".create-bundle-size__tier-marker");
    const sizeMarks = root.querySelectorAll("[data-create-bundle-size-mark]");

    const summaryProgressEl = root.querySelector("[data-create-bundle-progress]");
    const summaryTierLabelEl = root.querySelector("[data-create-bundle-tier-label]");
    const originalTotalEl = root.querySelector("[data-create-bundle-original-total]");
    const finalTotalEl = root.querySelector("[data-create-bundle-final-total]");
    const savingsEl = root.querySelector("[data-create-bundle-savings]");
    const helperEl = root.querySelector("[data-create-bundle-helper]");
    const addButton = root.querySelector("[data-create-bundle-add]");
    const addButtonMobile = root.querySelector("[data-create-bundle-add-mobile]");
    const mobileProgressEl = root.querySelector("[data-create-bundle-mobile-progress]");
    const mobileTotalEl = root.querySelector("[data-create-bundle-mobile-total]");

    const summaryToggle = root.querySelector("[data-create-bundle-summary-toggle]");
    const summaryDetails = root.querySelector("[data-create-bundle-summary-details]");

    const designModal = root.querySelector("[data-create-bundle-design-modal]");
    const designGrid = root.querySelector("[data-create-bundle-design-grid]");
    const designSearchInput = root.querySelector("[data-create-bundle-design-search]");
    const closeDesignModalButtons = root.querySelectorAll("[data-create-bundle-close-design-modal]");

    const productTypeModal = root.querySelector("[data-create-bundle-product-type-modal]");
    const productTypeGroupsMount = root.querySelector("[data-create-bundle-product-type-groups]");
    const closeProductTypeModalButtons = root.querySelectorAll("[data-create-bundle-close-product-type-modal]");

    const resetModal = root.querySelector("[data-create-bundle-reset-modal]");
const closeResetModalButtons = root.querySelectorAll("[data-create-bundle-close-reset-modal]");
const confirmResetButton = root.querySelector("[data-create-bundle-confirm-reset]");


    const addButtonSpinner = addButton?.querySelector('.create-bundle-summary__add-spinner');
const addButtonMobileSpinner = addButtonMobile?.querySelector('.create-bundle-summary__add-spinner');

 const state = {
      bundleSize: 3,
  discountPercent: 20,
  lastChosenDesignHandle: "",
  activeDesignModalSlotIndex: null,
  activeProductTypeModalSlotIndex: null,
  pendingResetSlotIndex: null,
  productJsonCache: {},
  slots: []
    };


    function setAddButtonsLoading(isLoading) {
  [addButton, addButtonMobile].forEach((button) => {
    if (!button) return;
    button.classList.toggle('is-loading', isLoading);
  });

  if (addButtonSpinner) {
    addButtonSpinner.classList.toggle('hidden', !isLoading);
  }

  if (addButtonMobileSpinner) {
    addButtonMobileSpinner.classList.toggle('hidden', !isLoading);
  }
}



function openResetModal(slotIndex) {
  state.pendingResetSlotIndex = slotIndex;
  if (resetModal) resetModal.hidden = false;
}

function closeResetModal() {
  state.pendingResetSlotIndex = null;
  if (resetModal) resetModal.hidden = true;
}

function performResetSlot(slotIndex) {
  const current = state.slots[slotIndex];
  if (!current) return;

  const retainedDesign =
    current.designHandle
      ? {
          handle: current.designHandle,
          name: current.designName,
          image: current.designImage
        }
      : null;

  state.slots[slotIndex] = {
    ...createEmptySlot(slotIndex, retainedDesign),
    designInherited: current.designInherited,
    errorMessage: "",
    unavailableMessage: ""
  };

  commitUI();
}

function requestResetSlot(slotIndex, triggerButton = null) {
  const slot = state.slots[slotIndex];
  if (!slot) return;

  const needsConfirm = !!(slot.productId || slot.variantId || slot.productType);

  if (!needsConfirm) {
    performResetSlot(slotIndex);
    if (triggerButton) {
      flashButtonText(triggerButton, "Cleared", "Reset");
    }
    return;
  }

  openResetModal(slotIndex);
}

   

    const PRODUCT_TYPE_GROUPS = {
      "Phone Cases": [
        "Snap Case",
        "Tough Case",
        "MagSafe Tough Case",
        "Biodegradable Case",
        "Flip Case"
      ],
      "Earbuds Cases": [
        "Apple AirPods Case",
        "Apple AirPods Max Case",
        "Samsung Buds Case",
        "Google Pixel Buds Case"
      ],
      "Laptop Protection": [
        "Premium Laptop Sleeve",
        "MacBook Case"
      ],
      "Drinkware": [
        "Large Tumbler",
        "Insulated Travel Mug"
      ],
      "Accessories": [
        "Ring Holder",
        "AirTag Holder",
        "Mobile Display Stand",
        "Wireless Charger",
        "Phone Grip",
        "Crossbody Phone Purse"
      ],
      "Tech Essentials": [
        "Premium Screen Protector",
        "Classic Phone Strap",
        "UV Phone Sanitizer"
      ]
    };

    const NORMALIZED_TYPE_MAP = {
      "Snap Case": "Snap Case",
      "Tough Case": "Tough Case",
      "MagSafe Tough Case": "MagSafe Tough Case",
      "Biodegradable Case": "Biodegradable Case",
      "Flip Case": "Flip Case",

      "Apple AirPods Case": "Apple AirPods Case",
      "Apple Airpods Case": "Apple AirPods Case",
      "AirPods Case": "Apple AirPods Case",

      "Apple AirPods Max Case": "Apple AirPods Max Case",
      "Apple Airpods Max Case": "Apple AirPods Max Case",
      "AirPods Max Case": "Apple AirPods Max Case",

      "Samsung Buds Case": "Samsung Buds Case",
      "Google Pixel Buds Case": "Google Pixel Buds Case",

      "Premium Laptop Sleeve": "Premium Laptop Sleeve",
      "MacBook Case": "MacBook Case",

      "Large Tumbler": "Large Tumbler",
      "Insulated Travel Mug": "Insulated Travel Mug",

      "Ring Holder": "Ring Holder",
      "Magnetic Ring Holder": "Ring Holder",

      "AirTag Holder": "AirTag Holder",
      "Airtag Holder": "AirTag Holder",

      "Mobile Display Stand": "Mobile Display Stand",

      "Wireless Charger": "Wireless Charger",
      "Wireless Chargers": "Wireless Charger",

      "Phone Grip": "Phone Grip",
      "Crossbody Phone Purse": "Crossbody Phone Purse",

      "Premium Screen Protector": "Premium Screen Protector",
      "Classic Phone Strap": "Classic Phone Strap",
      "UV Phone Sanitizer": "UV Phone Sanitizer"
    };

    const GLOBAL_PRODUCT_TYPES = [
      "Premium Screen Protector",
      "Classic Phone Strap",
      "UV Phone Sanitizer"
    ];

    const addButtonWrap = root.querySelector("[data-create-bundle-add-wrap]");
const addButtonTooltip = root.querySelector("[data-create-bundle-add-tooltip]");


const mobileSummaryToggle = root.querySelector("[data-create-bundle-mobile-summary-toggle]");
const mobileSummaryPanel = root.querySelector("[data-create-bundle-mobile-summary-panel]");
const mobileSummaryDetails = root.querySelector("[data-create-bundle-mobile-summary-details]");
const mobileOriginalTotalEl = root.querySelector("[data-create-bundle-mobile-original-total]");
const mobileFinalTotalEl = root.querySelector("[data-create-bundle-mobile-final-total]");
const mobileSavingsEl = root.querySelector("[data-create-bundle-mobile-savings]");
const mobileSummaryToggleText = root.querySelector(".create-bundle__mobile-summary-toggle-text");

const STORAGE_KEY = "casenari_create_bundle_state_v2";
const STORAGE_TTL_MS = 60 * 60 * 1000; // 1 hour


const noticesEl = root.querySelector("[data-create-bundle-notices]");
const mobileNoticesEl = root.querySelector("[data-create-bundle-mobile-notices]");
const noticesWrapEl = root.querySelector("[data-create-bundle-notices-wrap]");
const mobileNoticesWrapEl = root.querySelector("[data-create-bundle-mobile-notices-wrap]");


const shareButtons = root.querySelectorAll("[data-create-bundle-share]");
const statusMessageEl = root.querySelector("[data-create-bundle-status-message]");

const progressFillEl = root.querySelector("[data-create-bundle-progress-fill]");
const mobileProgressFillEl = root.querySelector("[data-create-bundle-mobile-progress-fill]");


    function getSerializableState() {
  return {
    bundleSize: state.bundleSize,
    discountPercent: state.discountPercent,
    lastChosenDesignHandle: state.lastChosenDesignHandle,
    slots: state.slots.map((slot) => ({
      slotIndex: slot.slotIndex,
      designHandle: slot.designHandle,
      designName: slot.designName,
      designImage: slot.designImage,
      designInherited: slot.designInherited,
      productType: slot.productType,
      productId: slot.productId,
      productTitle: slot.productTitle,
      productHandle: slot.productHandle,
      productUrl: slot.productUrl,
      productImage: slot.productImage,
      productPrice: slot.productPrice,
      selectedOptions: slot.selectedOptions,
      variantId: slot.variantId,
      variantTitle: slot.variantTitle,
      variantPrice: slot.variantPrice,
      complete: slot.complete
    }))
  };
}

function saveStateToStorage() {
  try {
    const payload = {
      savedAt: Date.now(),
      state: getSerializableState()
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.error("Failed to save bundle state", error);
  }
}

function loadStateFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;

    const payload = JSON.parse(raw);
    if (!payload || !payload.state || !Array.isArray(payload.state.slots)) return false;

    const savedAt = Number(payload.savedAt || 0);
    const isExpired = !savedAt || (Date.now() - savedAt > STORAGE_TTL_MS);

    if (isExpired) {
      localStorage.removeItem(STORAGE_KEY);
      return false;
    }

    const saved = payload.state;

    state.bundleSize = Number(saved.bundleSize || 3);
    state.discountPercent = getDiscountPercent(state.bundleSize);
    state.lastChosenDesignHandle = saved.lastChosenDesignHandle || "";

    resizeSlots(state.bundleSize);

    saved.slots.forEach((savedSlot, index) => {
      if (!state.slots[index]) return;

      state.slots[index] = {
        ...state.slots[index],
        ...savedSlot,
        slotIndex: index,
        productJson: null,
        loadingProduct: false
      };
    });

    return true;
  } catch (error) {
    console.error("Failed to load bundle state", error);
    return false;
  }
}

function clearSavedState() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear saved bundle state", error);
  }
}

function commitUI() {
  renderSlots();
  renderSummary();
  saveStateToStorage();
}


function serializeStateForUrl() {
  const payload = {
    bundleSize: state.bundleSize,
    slots: state.slots.map((slot) => ({
      d: slot.designHandle || "",
      t: slot.productType || "",
      h: slot.productHandle || "",
      o: slot.selectedOptions || [],
      v: slot.variantId || ""
    }))
  };

  return encodeURIComponent(btoa(JSON.stringify(payload)));
}

function restoreStateFromUrl() {
  try {
    const url = new URL(window.location.href);
    const encoded = url.searchParams.get("bundle");
    if (!encoded) return false;

    const parsed = JSON.parse(atob(decodeURIComponent(encoded)));
    if (!parsed || !Array.isArray(parsed.slots)) return false;

    state.bundleSize = Number(parsed.bundleSize || 3);
    state.discountPercent = getDiscountPercent(state.bundleSize);
    resizeSlots(state.bundleSize);

    parsed.slots.forEach((savedSlot, index) => {
      if (!state.slots[index]) return;

      const design = savedSlot.d ? getDesignByHandle(savedSlot.d) : null;

      state.slots[index] = {
        ...state.slots[index],
        designHandle: savedSlot.d || "",
        designName: design?.name || "",
        designImage: design?.image || "",
        productType: savedSlot.t || "",
        productHandle: savedSlot.h || "",
        selectedOptions: Array.isArray(savedSlot.o) ? savedSlot.o : [],
        variantId: savedSlot.v || null
      };
    });

    return true;
  } catch (error) {
    console.error("Failed to restore state from URL", error);
    return false;
  }
}


function getSummaryNotices() {
  const configuredSlots = state.slots.filter((slot) => slot.productId);
  const notices = [];

  const duplicateMap = new Map();
  configuredSlots.forEach((slot) => {
    const key = `${slot.productHandle}__${slot.variantId}`;
    duplicateMap.set(key, (duplicateMap.get(key) || 0) + 1);
  });

  const duplicateCount = Array.from(duplicateMap.values()).filter((count) => count > 1).reduce((sum, count) => sum + count, 0);
  if (duplicateCount > 1) {
    notices.push(`${duplicateCount} slots contain the exact same item.`);
  }

  const uniqueDesignHandles = [...new Set(configuredSlots.map((slot) => slot.designHandle).filter(Boolean))];
  if (uniqueDesignHandles.length > 1) {
    notices.push("This bundle includes products from different design groups.");
  }

  if (configuredSlots.some((slot) => isGlobalProductType(slot.productType))) {
    notices.push("This bundle includes non-design products.");
  }

  return notices;
}



function renderSummaryNotices() {
  const notices = getSummaryNotices();

  if (noticesEl && noticesWrapEl) {
    if (!notices.length) {
      noticesWrapEl.hidden = true;
      noticesEl.innerHTML = "";
    } else {
      noticesWrapEl.hidden = false;
      noticesEl.innerHTML = notices
        .map((notice) => `<div class="create-bundle-summary__notice">${escapeHtml(notice)}</div>`)
        .join("");
    }
  }

  if (mobileNoticesEl && mobileNoticesWrapEl) {
    if (!notices.length) {
      mobileNoticesWrapEl.hidden = true;
      mobileNoticesEl.innerHTML = "";
    } else {
      mobileNoticesWrapEl.hidden = false;
      mobileNoticesEl.innerHTML = notices
        .map((notice) => `<div class="create-bundle-summary__notice">${escapeHtml(notice)}</div>`)
        .join("");
    }
  }
}




    function escapeHtml(value) {
      return String(value || "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }





    function normalizeProductType(type) {
      return NORMALIZED_TYPE_MAP[String(type || "").trim()] || String(type || "").trim();
    }

    function formatMoney(value) {
      const number = Number(value || 0);
      return `$${number.toFixed(2)}`;
    }

    function getDiscountPercent(bundleSize) {
      const size = Number(bundleSize || 0);
      if (size >= 9) return 30;
      if (size >= 6) return 25;
      if (size >= 3) return 20;
      return 0;
    }

    function calculateDiscountedTotal(total, discountPercent) {
      return Number(total || 0) * (1 - Number(discountPercent || 0) / 100);
    }

    function createEmptySlot(slotIndex, inheritedDesign = null) {
      return {
        slotIndex,
        designHandle: inheritedDesign?.handle || "",
        designName: inheritedDesign?.name || "",
        designImage: inheritedDesign?.image || "",
        designInherited: !!inheritedDesign,

        productType: "",
        productId: null,
        productTitle: "",
        productHandle: "",
        productUrl: "",
        productImage: "",
        productPrice: 0,

        productJson: null,
        selectedOptions: [],
        variantId: null,
        variantTitle: "",
        variantPrice: 0,

        loadingProduct: false,
        complete: false,

        errorMessage: "",
        unavailableMessage: ""
      };
    }

    function getDesignByHandle(handle) {
      return designGroups.find((group) => String(group.handle) === String(handle)) || null;
    }

    function isGlobalProductType(productType) {
      return GLOBAL_PRODUCT_TYPES.includes(normalizeProductType(productType));
    }

    function getMatchedProductForSlot(slot) {
      if (!slot.productType) return null;

      const normalizedTarget = normalizeProductType(slot.productType);

      if (isGlobalProductType(normalizedTarget)) {
        return (
          globalProducts.find((product) => normalizeProductType(product.type) === normalizedTarget) || null
        );
      }

      if (!slot.designHandle) return null;

      const designGroup = getDesignByHandle(slot.designHandle);
      if (!designGroup) return null;

      return (
        designGroup.products.find((product) => normalizeProductType(product.type) === normalizedTarget) || null
      );
    }

    function getAvailableProductsForSlot(slot) {
  const grouped = {};

  Object.keys(PRODUCT_TYPE_GROUPS).forEach((groupName) => {
    grouped[groupName] = [];
  });

  const designGroup = slot.designHandle ? getDesignByHandle(slot.designHandle) : null;
  const designProducts = designGroup?.products || [];

  designProducts.forEach((product) => {
    const normalizedType = normalizeProductType(product.type);

    Object.entries(PRODUCT_TYPE_GROUPS).forEach(([groupName, types]) => {
      if (groupName === "Tech Essentials") return;

      if (types.includes(normalizedType)) {
        const existing = grouped[groupName].find(
          (entry) => normalizeProductType(entry.type) === normalizedType
        );

        if (!existing) {
          grouped[groupName].push({
            ...product,
            displayType: normalizedType
          });
        }
      }
    });
  });

  globalProducts.forEach((product) => {
    const normalizedType = normalizeProductType(product.type);

    if (PRODUCT_TYPE_GROUPS["Tech Essentials"].includes(normalizedType)) {
      const existing = grouped["Tech Essentials"].find(
        (entry) => normalizeProductType(entry.type) === normalizedType
      );

      if (!existing) {
        grouped["Tech Essentials"].push({
          ...product,
          displayType: normalizedType
        });
      }
    }
  });

  return grouped;
}

    function getDefaultVariant(productJson) {
      if (!productJson?.variants?.length) return null;
      return (
        productJson.variants.find((variant) => variant.available) ||
        productJson.variants[0] ||
        null
      );
    }

    function getUniqueOptionValues(productJson, optionIndex, selectedOptions) {
      const key = `option${optionIndex + 1}`;

      return productJson.variants
        .filter((variant) => {
          return selectedOptions.every((value, index) => {
            if (index === optionIndex) return true;
            if (!value) return true;
            return variant[`option${index + 1}`] === value;
          });
        })
        .map((variant) => variant[key])
        .filter((value, index, array) => value && array.indexOf(value) === index);
    }

    function findMatchingVariant(productJson, selectedOptions) {
      if (!productJson?.variants?.length) return null;

      return (
        productJson.variants.find((variant) => {
          return selectedOptions.every((value, index) => {
            if (!value) return true;
            return variant[`option${index + 1}`] === value;
          });
        }) ||
        getDefaultVariant(productJson)
      );
    }

    async function fetchProductJson(handle) {
      if (!handle) return null;

      if (state.productJsonCache[handle]) {
        return state.productJsonCache[handle];
      }

      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        throw new Error(`Failed to fetch product JSON for ${handle}`);
      }

      const productJson = await response.json();
      state.productJsonCache[handle] = productJson;
      return productJson;
    }

    function isSlotComplete(slot) {
      return !!(slot.productType && slot.productId && slot.variantId);
    }

    function getCompletedCount() {
      return state.slots.filter((slot) => slot.complete).length;
    }

    function getOriginalTotal() {
      return state.slots.reduce((sum, slot) => sum + Number(slot.variantPrice || 0), 0);
    }

    function propagateDesignForward(fromSlotIndex, designData) {
      state.slots.forEach((slot, index) => {
        if (index <= fromSlotIndex) return;

        const slotIsUntouched =
          !slot.productType &&
          !slot.productId &&
          !slot.variantId &&
          (!slot.designHandle || slot.designInherited);

        if (slotIsUntouched) {
          slot.designHandle = designData.handle;
          slot.designName = designData.name;
          slot.designImage = designData.image;
          slot.designInherited = true;
        }
      });
    }

    function resizeSlots(nextSize) {
      const currentLength = state.slots.length;

      if (nextSize > currentLength) {
        const inheritedDesign = state.lastChosenDesignHandle
          ? getDesignByHandle(state.lastChosenDesignHandle)
          : null;

        for (let i = currentLength; i < nextSize; i += 1) {
          state.slots.push(createEmptySlot(i, inheritedDesign));
        }
      } else if (nextSize < currentLength) {
        state.slots = state.slots.slice(0, nextSize);
      }

      state.slots = state.slots.map((slot, index) => ({
        ...slot,
        slotIndex: index
      }));
    }

    function getSlotPriceMarkup(slot) {
      const original = Number(slot.variantPrice || slot.productPrice || 0);
      const discounted = calculateDiscountedTotal(original, state.discountPercent);

      if (!original) return "";

      return `
        <div class="create-bundle-slot-preview__price">
          <span class="create-bundle-slot-preview__price-compare">${formatMoney(original)}</span>
          <span class="create-bundle-slot-preview__price-final">${formatMoney(discounted)}</span>
        </div>
      `;
    }

    function renderVariantPickers(slot) {
  if (!slot.productJson?.options?.length) {
    return `<div class="create-bundle-slot-preview__note">Loading options…</div>`;
  }

  return slot.productJson.options
    .map((option, optionIndex) => {
      const optionLabel = getProductOptionLabel(option, optionIndex);
      const values = getUniqueOptionValues(slot.productJson, optionIndex, slot.selectedOptions);
      if (!values.length) return "";

      return `
        <div class="create-bundle-slot-preview__variant-group">
          <label class="create-bundle-slot-preview__variant-label" for="CreateBundleVariant-${slot.slotIndex}-${optionIndex}">
            ${escapeHtml(optionLabel)}
          </label>

          <select
            id="CreateBundleVariant-${slot.slotIndex}-${optionIndex}"
            class="select__select create-bundle-slot-preview__variant-select"
            data-create-bundle-variant-select
            data-slot-index="${slot.slotIndex}"
            data-option-index="${optionIndex}"
          >
            ${values
              .map(
                (value) => `
                  <option value="${escapeHtml(value)}" ${slot.selectedOptions[optionIndex] === value ? "selected" : ""}>
                    ${escapeHtml(value)}
                  </option>
                `
              )
              .join("")}
          </select>
        </div>
      `;
    })
    .join("");
}

    function buildSlotPreview(slot) {
  if (!slot.productType) {
    return `<div class="create-bundle-slot__empty-state">Choose a product type to continue.</div>`;
  }

  const matchedProduct = getMatchedProductForSlot(slot);

  if (!matchedProduct) {
    return `<div class="create-bundle-slot__empty-state">No matching product found for this design and product type.</div>`;
  }

  const isNonDesignProduct = isGlobalProductType(slot.productType);

  return `
    <div class="create-bundle-slot-preview">
      <div class="create-bundle-slot-preview__media">
        ${matchedProduct.featuredImage ? `<img src="${matchedProduct.featuredImage}" alt="${escapeHtml(matchedProduct.title)}" class="create-bundle-slot-preview__image">` : ""}
      </div>

      <div class="create-bundle-slot-preview__content">
        <h4 class="create-bundle-slot-preview__title">${escapeHtml(matchedProduct.title)}</h4>
        ${getSlotPriceMarkup(slot)}

        ${isNonDesignProduct ? `<div class="create-bundle-slot-preview__note">This item does not use the selected design. Your design selection remains unchanged for this slot.</div>` : ""}

        ${slot.loadingProduct ? `<div class="create-bundle-slot-preview__note">Loading product options…</div>` : ""}

        ${slot.errorMessage ? `
          <div class="create-bundle-slot-preview__error">
            ${escapeHtml(slot.errorMessage)}
            <button
              type="button"
              class="create-bundle-slot-preview__retry"
              data-create-bundle-retry-slot
              data-slot-index="${slot.slotIndex}"
            >
              Retry
            </button>
          </div>
        ` : ""}

        ${slot.unavailableMessage ? `
          <div class="create-bundle-slot-preview__error">
            ${escapeHtml(slot.unavailableMessage)}
          </div>
        ` : ""}

        ${!slot.loadingProduct && !slot.errorMessage ? renderVariantPickers(slot) : ""}
      </div>
    </div>
  `;
}

    function renderSingleSlot(slot) {
      const hasDesign = !!slot.designHandle;
      const designName = slot.designName || "No design selected yet";
      const designMeta = hasDesign
        ? (slot.designInherited ? "Inherited default design" : "Custom design")
        : "Choose a design for this slot";

        const needsDesignFirst = !slot.designHandle;

      return `
        <div class="create-bundle-slot" data-create-bundle-slot="${slot.slotIndex}">
          <div class="create-bundle-slot__header">
            <h3 class="create-bundle-slot__title">#Item ${slot.slotIndex + 1}</h3>

            <div class="create-bundle-slot__header-right">
              <span class="create-bundle-slot__status ${slot.complete ? "is-complete" : ""}">
                ${slot.complete ? "Complete" : "Incomplete"}
              </span>

              <button
                type="button"
                class="create-bundle-slot__action"
                data-create-bundle-duplicate-slot
                data-slot-index="${slot.slotIndex}"
              >
                Duplicate
              </button>

              <button
                type="button"
                class="create-bundle-slot__action"
                data-create-bundle-reset-slot
                data-slot-index="${slot.slotIndex}"
              >
                Reset
              </button>
            </div>
          </div>

          <div class="create-bundle-slot__body">
            <div>
              <label class="create-bundle-slot__field-label">Design</label>

              <div class="create-bundle-slot__design-row">
                <div class="create-bundle-slot__design-preview">
                  <div class="create-bundle-slot__design-image-wrap">
                    ${slot.designImage ? `<img src="${slot.designImage}" alt="${escapeHtml(designName)}" class="create-bundle-slot__design-image">` : ""}
                  </div>

                  <div class="create-bundle-slot__design-text">
                    <span class="create-bundle-slot__design-name">${escapeHtml(designName)}</span>
                    <span class="create-bundle-slot__design-meta">${escapeHtml(designMeta)}</span>
                  </div>
                </div>

                <button
                  type="button"
                  class="button button--secondary create-bundle-slot__design-button"
                  data-create-bundle-open-design-modal
                  data-slot-index="${slot.slotIndex}"
                >
                  ${hasDesign ? "Change Design" : "Choose Design"}
                </button>
              </div>
            </div>

            <div>
              <label class="create-bundle-slot__field-label">Product Type</label>

              <div class="create-bundle-slot__product-type-wrap ${needsDesignFirst ? "is-disabled-hint" : ""}">
  <button
    type="button"
    class="button button--secondary create-bundle-slot__product-type-button ${needsDesignFirst ? "is-disabled" : ""}"
    data-create-bundle-open-product-type-modal
    data-slot-index="${slot.slotIndex}"
    ${needsDesignFirst ? "disabled" : ""}
  >
    ${slot.productType ? escapeHtml(slot.productType) : "Choose Product Type"}
  </button>

  ${
    needsDesignFirst
      ? `<span class="create-bundle-slot__product-type-tooltip">Choose design first</span>`
      : ""
  }
</div>
            </div>

            <div class="create-bundle-slot__mount" data-create-bundle-slot-mount data-slot-index="${slot.slotIndex}">
              ${buildSlotPreview(slot)}
            </div>
          </div>
        </div>
      `;
    }

    function renderSlots() {
      if (!slotsMount) return;

      slotsMount.innerHTML = state.slots.map(renderSingleSlot).join("");
      bindSlotEvents();
    }

    function renderSummaryDetails() {
  if (!summaryDetails) return;

  summaryDetails.innerHTML = state.slots
    .map((slot, index) => {
      const original = Number(slot.variantPrice || 0);
      const discounted = calculateDiscountedTotal(original, state.discountPercent);

      let statusLine = "";
      if (!slot.designHandle) statusLine = "Missing: design";
      else if (!slot.productType) statusLine = "Missing: product type";
      else if (!slot.variantId) statusLine = "Missing: variant";
      else statusLine = String(slot.variantTitle || "").replaceAll(" / ", " • ");

      return `
        <div class="create-bundle-summary__item ${slot.complete ? "is-complete" : ""}">
          <div class="create-bundle-summary__item-media">
            ${slot.productImage ? `<img src="${slot.productImage}" alt="${escapeHtml(slot.productTitle || `Item ${index + 1}`)}" class="create-bundle-summary__item-image">` : ""}
          </div>

          <div class="create-bundle-summary__item-content">
            <span class="create-bundle-summary__item-title">
              Item ${index + 1} — ${escapeHtml(slot.productTitle || slot.productType || "Not yet completed")}
            </span>
            <span class="create-bundle-summary__item-meta">
              ${escapeHtml(slot.designName || "No design selected")}
            </span>
            <span class="create-bundle-summary__item-meta">
              ${escapeHtml(statusLine)}
            </span>
          </div>

          <div class="create-bundle-summary__item-pricing">
            ${original ? `<span class="create-bundle-summary__item-price-compare">${formatMoney(original)}</span>` : ""}
            ${original ? `<span class="create-bundle-summary__item-price-final">${formatMoney(discounted)}</span>` : ""}
          </div>
        </div>
      `;
    })
    .join("");
}



    function renderMobileSummaryDetails() {
  if (!mobileSummaryDetails) return;

  mobileSummaryDetails.innerHTML = state.slots
    .map((slot, index) => {
      const original = Number(slot.variantPrice || 0);
      const discounted = calculateDiscountedTotal(original, state.discountPercent);

      let statusLine = "";
      if (!slot.designHandle) statusLine = "Missing: design";
      else if (!slot.productType) statusLine = "Missing: product type";
      else if (!slot.variantId) statusLine = "Missing: variant";
      else statusLine = String(slot.variantTitle || "").replaceAll(" / ", " • ");

      return `
        <div class="create-bundle-summary__item ${slot.complete ? "is-complete" : ""}">
          <div class="create-bundle-summary__item-media">
            ${slot.productImage ? `<img src="${slot.productImage}" alt="${escapeHtml(slot.productTitle || `Item ${index + 1}`)}" class="create-bundle-summary__item-image">` : ""}
          </div>

          <div class="create-bundle-summary__item-content">
            <span class="create-bundle-summary__item-title">
              Item ${index + 1} — ${escapeHtml(slot.productTitle || slot.productType || "Not yet completed")}
            </span>
            <span class="create-bundle-summary__item-meta">
              ${escapeHtml(slot.designName || "No design selected")}
            </span>
            <span class="create-bundle-summary__item-meta">
              ${escapeHtml(statusLine)}
            </span>
          </div>

          <div class="create-bundle-summary__item-pricing">
            ${original ? `<span class="create-bundle-summary__item-price-compare">${formatMoney(original)}</span>` : ""}
            ${original ? `<span class="create-bundle-summary__item-price-final">${formatMoney(discounted)}</span>` : ""}
          </div>
        </div>
      `;
    })
    .join("");
}



    function updateTierVisuals() {
      const size = state.bundleSize;

      tierCards.forEach((card, index) => {
        const isActive =
          (index === 0 && size >= 3 && size <= 5) ||
          (index === 1 && size >= 6 && size <= 8) ||
          (index === 2 && size >= 9 && size <= 10);

        card.classList.toggle("is-active", isActive);
      });

      sizeMarks.forEach((mark) => {
        const value = Number(mark.dataset.createBundleSizeMark || mark.dataset.bundleSizeMark || mark.getAttribute("data-create-bundle-size-mark"));
        const isCurrent = value === size;
        const isPassed = value <= size;

        mark.classList.toggle("is-current", isCurrent);
        mark.classList.toggle("is-active", isPassed);
      });
    }

    

   function renderSummary() {
  const completedCount = getCompletedCount();
  const originalTotal = getOriginalTotal();
  const discountedTotal = calculateDiscountedTotal(originalTotal, state.discountPercent);
  const savings = originalTotal - discountedTotal;
  const isComplete = completedCount === state.bundleSize;

  const progressPercent = state.bundleSize > 0
    ? Math.round((completedCount / state.bundleSize) * 100)
    : 0;

  if (progressFillEl) {
    progressFillEl.style.width = `${progressPercent}%`;
  }

  if (mobileProgressFillEl) {
    mobileProgressFillEl.style.width = `${progressPercent}%`;
  }

  if (sizeValueEl) sizeValueEl.textContent = String(state.bundleSize);
  if (discountBadgeEl) discountBadgeEl.textContent = `${state.discountPercent}% OFF`;

  if (summaryProgressEl) {
    summaryProgressEl.textContent = `${completedCount} / ${state.bundleSize} completed`;
  }

  if (summaryTierLabelEl) {
    summaryTierLabelEl.textContent = `${state.discountPercent}% off unlocked`;
  }

  if (originalTotalEl) {
    originalTotalEl.textContent = formatMoney(originalTotal);
  }

  if (finalTotalEl) {
    finalTotalEl.textContent = formatMoney(discountedTotal);
  }

  if (savingsEl) {
    savingsEl.textContent = formatMoney(savings);
  }

  if (mobileProgressEl) {
    mobileProgressEl.textContent = `${completedCount} / ${state.bundleSize} completed`;
  }

  if (mobileTotalEl) {
    mobileTotalEl.textContent = formatMoney(discountedTotal);
  }

  if (mobileOriginalTotalEl) {
    mobileOriginalTotalEl.textContent = formatMoney(originalTotal);
  }

  if (mobileFinalTotalEl) {
    mobileFinalTotalEl.textContent = formatMoney(discountedTotal);
  }

  if (mobileSavingsEl) {
    mobileSavingsEl.textContent = formatMoney(savings);
  }

  if (helperEl) {
    if (completedCount === 0) {
      helperEl.textContent = "Choose your design and product type to start building your bundle.";
    } else if (isComplete) {
      helperEl.textContent = "Your bundle is ready. Review your items below, then add everything to cart.";
    } else {
      helperEl.textContent = `You’ve completed ${completedCount} of ${state.bundleSize} items. Finish the remaining slots to add your bundle.`;
    }
  }

  if (addButton) {
    addButton.disabled = !isComplete;
    addButton.classList.toggle("is-disabled", !isComplete);
  }

  if (addButtonMobile) {
    addButtonMobile.disabled = !isComplete;
  }

  if (addButtonWrap) {
    addButtonWrap.classList.toggle("is-disabled-hint", !isComplete);
  }

  if (addButtonTooltip) {
    addButtonTooltip.hidden = isComplete;
  }

  shareButtons.forEach((button) => {
    button.disabled = !isComplete;
    button.classList.toggle("is-disabled", !isComplete);
  });

  updateTierVisuals();
  renderSummaryDetails();
  renderMobileSummaryDetails();
  renderSummaryNotices();
}




    function bindMobileSummaryEvents() {
  if (!mobileSummaryToggle || !mobileSummaryPanel) return;

  mobileSummaryToggle.addEventListener("click", () => {
    const isOpen = mobileSummaryToggle.getAttribute("aria-expanded") === "true";

    mobileSummaryToggle.setAttribute("aria-expanded", String(!isOpen));
    mobileSummaryPanel.hidden = isOpen;

    if (mobileSummaryToggleText) {
      mobileSummaryToggleText.textContent = isOpen ? "Show Bundle Details" : "Hide Bundle Details";
    }
  });
}


    function openDesignModal(slotIndex) {
      state.activeDesignModalSlotIndex = slotIndex;
      if (!designModal) return;
      designModal.hidden = false;
      renderDesignModal();
    }

    function closeDesignModal() {
      if (!designModal) return;
      designModal.hidden = true;
      state.activeDesignModalSlotIndex = null;
    }

    function renderDesignModal() {
      if (!designGrid) return;

      const query = String(designSearchInput?.value || "").trim().toLowerCase();

      const filteredGroups = designGroups.filter((group) => {
        if (!query) return true;
        return String(group.name || "").toLowerCase().includes(query);
      });

      if (!filteredGroups.length) {
        designGrid.innerHTML = `<div class="create-bundle-slot__empty-state">No designs found.</div>`;
        return;
      }

      designGrid.innerHTML = filteredGroups
        .map((group) => {
          return `
            <button
              type="button"
              class="create-bundle-modal__card"
              data-create-bundle-select-design
              data-design-handle="${group.handle}"
            >
              <span class="create-bundle-modal__card-image-wrap">
                ${group.image ? `<img src="${group.image}" alt="${escapeHtml(group.name)}" class="create-bundle-modal__card-image">` : ""}
              </span>
              <span class="create-bundle-modal__card-name">${escapeHtml(group.name)}</span>
            </button>
          `;
        })
        .join("");

      designGrid.querySelectorAll("[data-create-bundle-select-design]").forEach((button) => {
        button.addEventListener("click", () => {
          const slotIndex = state.activeDesignModalSlotIndex;
          const slot = state.slots[slotIndex];
          const design = getDesignByHandle(button.dataset.designHandle);

          if (!slot || !design) return;

          slot.designHandle = design.handle;
          slot.designName = design.name;
          slot.designImage = design.image;
          slot.designInherited = false;

          if (!slot.productType) {
            slot.productId = null;
            slot.productTitle = "";
            slot.productHandle = "";
            slot.productUrl = "";
            slot.productImage = "";
            slot.productPrice = 0;
            slot.productJson = null;
            slot.selectedOptions = [];
            slot.variantId = null;
            slot.variantTitle = "";
            slot.variantPrice = 0;
            slot.complete = false;
          } else {
            const matchedProduct = getMatchedProductForSlot(slot);

            if (matchedProduct) {
              slot.productId = matchedProduct.id;
              slot.productTitle = matchedProduct.title;
              slot.productHandle = matchedProduct.handle || "";
              slot.productUrl = matchedProduct.url || "";
              slot.productImage = matchedProduct.featuredImage || "";
              slot.productPrice = Number(matchedProduct.price || 0);
              slot.productJson = null;
              slot.selectedOptions = [];
              slot.variantId = null;
              slot.variantTitle = "";
              slot.variantPrice = 0;
              slot.complete = false;
              hydrateSlotProduct(slot.slotIndex);
            } else {
              slot.productId = null;
              slot.productTitle = "";
              slot.productHandle = "";
              slot.productUrl = "";
              slot.productImage = "";
              slot.productPrice = 0;
              slot.productJson = null;
              slot.selectedOptions = [];
              slot.variantId = null;
              slot.variantTitle = "";
              slot.variantPrice = 0;
              slot.complete = false;
            }
          }

          state.lastChosenDesignHandle = design.handle;
          propagateDesignForward(slotIndex, design);

          commitUI();
          closeDesignModal();
        });
      });
    }

    function openProductTypeModal(slotIndex) {
      state.activeProductTypeModalSlotIndex = slotIndex;
      if (!productTypeModal) return;
      productTypeModal.hidden = false;
      renderProductTypeModal();
    }

    function closeProductTypeModal() {
      if (!productTypeModal) return;
      productTypeModal.hidden = true;
      state.activeProductTypeModalSlotIndex = null;
    }


    function getProductOptionLabel(option, optionIndex) {
  if (typeof option === "string") return option;
  if (option && typeof option === "object") return option.name || `Option ${optionIndex + 1}`;
  return `Option ${optionIndex + 1}`;
}

function getVariantOptionValue(variant, optionIndex) {
  if (!variant) return "";
  if (Array.isArray(variant.options)) {
    return variant.options[optionIndex] || "";
  }
  return variant[`option${optionIndex + 1}`] || "";
}

function getUniqueOptionValues(productJson, optionIndex, selectedOptions) {
  return productJson.variants
    .filter((variant) => {
      return selectedOptions.every((value, index) => {
        if (index === optionIndex) return true;
        if (!value) return true;
        return getVariantOptionValue(variant, index) === value;
      });
    })
    .map((variant) => getVariantOptionValue(variant, optionIndex))
    .filter((value, index, array) => value && array.indexOf(value) === index);
}

function findMatchingVariant(productJson, selectedOptions) {
  if (!productJson?.variants?.length) return null;

  return (
    productJson.variants.find((variant) => {
      return selectedOptions.every((value, index) => {
        if (!value) return true;
        return getVariantOptionValue(variant, index) === value;
      });
    }) ||
    getDefaultVariant(productJson)
  );
}



    function renderProductTypeModal() {
  if (!productTypeGroupsMount) return;

  const slot = state.slots[state.activeProductTypeModalSlotIndex];
  if (!slot) return;

  const grouped = getAvailableProductsForSlot(slot);

  const orderedGroupNames = [
    "Phone Cases",
    "Earbuds Cases",
    "Laptop Protection",
    "Drinkware",
    "Accessories",
    "Tech Essentials"
  ];

  productTypeGroupsMount.innerHTML = orderedGroupNames
    .map((groupName) => {
      const products = grouped[groupName] || [];
      if (!products.length) return "";

      return `
        <div class="create-bundle-product-type-group">
          <h3 class="create-bundle-product-type-group__title">${escapeHtml(groupName === "Tech Essentials" ? "Tech Essentials (Non-Design)" : groupName)}</h3>
          <div class="create-bundle-product-type-group__grid">
            ${products
              .map(
                (product) => `
                  <button
                    type="button"
                    class="create-bundle-modal__card create-bundle-modal__card--product-type ${slot.productType === product.displayType ? "is-active" : ""}"
                    data-create-bundle-select-product-type
                    data-product-type="${escapeHtml(product.displayType)}"
                  >
                    <span class="create-bundle-modal__card-image-wrap">
                      ${product.featuredImage ? `<img src="${product.featuredImage}" alt="${escapeHtml(product.displayType)}" class="create-bundle-modal__card-image">` : ""}
                    </span>
                    <span class="create-bundle-modal__card-name">${escapeHtml(product.displayType)}</span>
                  </button>
                `
              )
              .join("")}
          </div>
        </div>
      `;
    })
    .join("");

  productTypeGroupsMount.querySelectorAll("[data-create-bundle-select-product-type]").forEach((button) => {
    button.addEventListener("click", () => {
      const slot = state.slots[state.activeProductTypeModalSlotIndex];
      if (!slot) return;

      slot.productType = button.dataset.productType;
      slot.productId = null;
      slot.productTitle = "";
      slot.productHandle = "";
      slot.productUrl = "";
      slot.productImage = "";
      slot.productPrice = 0;
      slot.productJson = null;
      slot.selectedOptions = [];
      slot.variantId = null;
      slot.variantTitle = "";
      slot.variantPrice = 0;
      slot.complete = false;

      const matchedProduct = getMatchedProductForSlot(slot);
      if (matchedProduct) {
        slot.productId = matchedProduct.id;
        slot.productTitle = matchedProduct.title;
        slot.productHandle = matchedProduct.handle || "";
        slot.productUrl = matchedProduct.url || "";
        slot.productImage = matchedProduct.featuredImage || "";
        slot.productPrice = Number(matchedProduct.price || 0);
        hydrateSlotProduct(slot.slotIndex);
      }

      commitUI();
      closeProductTypeModal();
    });
  });
}

    async function hydrateSlotProduct(slotIndex) {
  const slot = state.slots[slotIndex];
  if (!slot?.productHandle) return;

  slot.loadingProduct = true;
  slot.errorMessage = "";
  slot.unavailableMessage = "";
  commitUI();

  try {
    const productJson = await fetchProductJson(slot.productHandle);
    const defaultVariant = getDefaultVariant(productJson);

    slot.productJson = productJson;
    slot.selectedOptions = [
      defaultVariant?.option1 || "",
      defaultVariant?.option2 || "",
      defaultVariant?.option3 || ""
    ];
    slot.variantId = defaultVariant?.id || null;
    slot.variantTitle = defaultVariant?.title || "";
    slot.variantPrice = Number((defaultVariant?.price || 0) / 100);

    if (!defaultVariant || defaultVariant.available === false) {
      slot.unavailableMessage = "This item is currently unavailable. Please choose another product.";
      slot.complete = false;
    } else {
      slot.unavailableMessage = "";
      slot.complete = isSlotComplete(slot);
    }
  } catch (error) {
    console.error("Failed to hydrate slot product", error);
    slot.productJson = null;
    slot.selectedOptions = [];
    slot.variantId = null;
    slot.variantTitle = "";
    slot.variantPrice = 0;
    slot.complete = false;
    slot.errorMessage = "We couldn’t load this product right now.";
  } finally {
    slot.loadingProduct = false;
    commitUI();
  }
}

    function duplicateSlotIntoNextEmpty(slotIndex) {
  const source = state.slots[slotIndex];
  if (!source || !source.complete) return false;

  const target = state.slots.find((slot) => !slot.complete && slot.slotIndex !== slotIndex);
  if (!target) return false;

  target.designHandle = source.designHandle;
  target.designName = source.designName;
  target.designImage = source.designImage;
  target.designInherited = false;
  target.productType = source.productType;
  target.productId = source.productId;
  target.productTitle = source.productTitle;
  target.productHandle = source.productHandle;
  target.productUrl = source.productUrl;
  target.productImage = source.productImage;
  target.productPrice = source.productPrice;
  target.productJson = source.productJson;
  target.selectedOptions = [...source.selectedOptions];
  target.variantId = source.variantId;
  target.variantTitle = source.variantTitle;
  target.variantPrice = source.variantPrice;
  target.complete = source.complete;
  target.errorMessage = "";
  target.unavailableMessage = "";

  commitUI();
  return true;
}

  

    function bindSlotEvents() {
      slotsMount.querySelectorAll("[data-create-bundle-open-design-modal]").forEach((button) => {
        button.addEventListener("click", () => {
          openDesignModal(Number(button.dataset.slotIndex));
        });
      });

      slotsMount.querySelectorAll("[data-create-bundle-open-product-type-modal]").forEach((button) => {
        button.addEventListener("click", () => {
          const slotIndex = Number(button.dataset.slotIndex);
          const slot = state.slots[slotIndex];
          if (!slot?.designHandle) return;
          openProductTypeModal(slotIndex);
        });
      });

      slotsMount.querySelectorAll("[data-create-bundle-duplicate-slot]").forEach((button) => {
        button.addEventListener("click", () => {
          const didDuplicate = duplicateSlotIntoNextEmpty(Number(button.dataset.slotIndex));
    if (didDuplicate) {
      flashButtonText(button, "Duplicated", "Duplicate");
    }
        });
      });

      slotsMount.querySelectorAll("[data-create-bundle-reset-slot]").forEach((button) => {
        button.addEventListener("click", () => {
          requestResetSlot(Number(button.dataset.slotIndex));
        });
      });

      slotsMount.querySelectorAll("[data-create-bundle-variant-select]").forEach((select) => {
  select.addEventListener("change", () => {
    const slotIndex = Number(select.dataset.slotIndex);
    const optionIndex = Number(select.dataset.optionIndex);
    const slot = state.slots[slotIndex];
    if (!slot?.productJson) return;

    const nextSelectedOptions = [...slot.selectedOptions];
    nextSelectedOptions[optionIndex] = select.value;

    const nextVariant = findMatchingVariant(slot.productJson, nextSelectedOptions);

    slot.errorMessage = "";
    slot.unavailableMessage = "";

    if (!nextVariant || nextVariant.available === false) {
      slot.selectedOptions = nextSelectedOptions;
      slot.variantId = null;
      slot.variantTitle = "";
      slot.variantPrice = 0;
      slot.complete = false;
      slot.unavailableMessage = "This variant is unavailable. Please choose another option.";
      commitUI();
      return;
    }

    slot.selectedOptions = nextSelectedOptions;
    slot.variantId = nextVariant.id;
    slot.variantTitle = nextVariant.title || "";
    slot.variantPrice = Number((nextVariant.price || 0) / 100);
    slot.complete = isSlotComplete(slot);

    commitUI();
  });
});

      slotsMount.querySelectorAll("[data-create-bundle-retry-slot]").forEach((button) => {
  button.addEventListener("click", () => {
    hydrateSlotProduct(Number(button.dataset.slotIndex));
  });
});
    }

    function bindSummaryEvents() {
      if (summaryToggle && summaryDetails) {
        summaryToggle.addEventListener("click", () => {
          const isOpen = summaryToggle.getAttribute("aria-expanded") === "true";
          summaryToggle.setAttribute("aria-expanded", String(!isOpen));
          summaryToggle.textContent = isOpen ? "SHOW BREAKDOWN" : "HIDE BREAKDOWN";
          summaryDetails.hidden = isOpen;
        });
      }
    }

    function bindModalEvents() {
      closeDesignModalButtons.forEach((button) => {
        button.addEventListener("click", closeDesignModal);
      });

      closeProductTypeModalButtons.forEach((button) => {
        button.addEventListener("click", closeProductTypeModal);
      });

      if (designSearchInput) {
        designSearchInput.addEventListener("input", () => {
          renderDesignModal();
        });
      }

      closeResetModalButtons.forEach((button) => {
  button.addEventListener("click", closeResetModal);
});

confirmResetButton?.addEventListener("click", () => {
  if (state.pendingResetSlotIndex == null) return;
  performResetSlot(state.pendingResetSlotIndex);
  closeResetModal();
});
    }

    function generateBundleId() {
  return `cb_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

function buildCartItemsFromSlots(slots) {
  const bundleId = generateBundleId();
  const configuredSlots = slots.filter((slot) => slot.variantId);

  const hasMixedDesigns =
    new Set(configuredSlots.map((slot) => slot.designHandle).filter(Boolean)).size > 1;

  const hasNonDesignProducts = configuredSlots.some((slot) =>
    isGlobalProductType(slot.productType)
  );

  const discountPercent = String(state.discountPercent || 0);
  const bundleHandle = `custom-bundle-${discountPercent}`;
  const bundleDiscountKey = bundleHandle;

  return configuredSlots.map((slot, index) => ({
    id: slot.variantId,
    quantity: 1,
    properties: {
      _bundle_id: bundleId,
      _bundle_name: "Create Your Own Bundle",
      _bundle_handle: bundleHandle,
      _bundle_size: String(state.bundleSize),
      _bundle_discount_percent: discountPercent,
      _bundle_discount_key: bundleDiscountKey,
      _bundle_slot_index: String(index + 1),
      _bundle_slot_title: `Item ${index + 1}`,
      _bundle_design_name: slot.designName || "",
      _bundle_product_type: slot.productType || "",
      _bundle_variant_title: String(slot.variantTitle || "").replaceAll(" / ", " • "),
      _bundle_mixed_designs: hasMixedDesigns ? "true" : "false",
      _bundle_has_non_design_products: hasNonDesignProducts ? "true" : "false",
      _bundle_child: "true"
    }
  }));
}


function showStatusMessage(message) {
  if (!statusMessageEl) return;
  statusMessageEl.hidden = false;
  statusMessageEl.textContent = message;

  clearTimeout(showStatusMessage._timer);
  showStatusMessage._timer = setTimeout(() => {
    statusMessageEl.hidden = true;
    statusMessageEl.textContent = "";
  }, 2500);
}


function bindSaveAndShare() {
  shareButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      const allComplete = state.slots.every((slot) => slot.complete);
      if (!allComplete) return;

      try {
        const url = new URL(window.location.href);
        url.searchParams.set("bundle", serializeStateForUrl());

        const shareUrl = url.toString();
        const shareTitle = "Create Your Own Bundle";
        const shareText = "Check out this custom bundle I built.";

        const isMobileLike = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (navigator.share && isMobileLike) {
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: shareUrl
          });
          return;
        }

        await navigator.clipboard.writeText(shareUrl);
        flashButtonText(button, "Copied", "Share This Bundle");
      } catch (error) {
        if (error && error.name === "AbortError") {
          return;
        }

        console.error("Failed to share bundle", error);
        showStatusMessage("Could not share bundle.");
      }
    });
  });
}

    
    function getCartDrawer() {
  return document.querySelector("cart-drawer");
}

async function renderCartDrawer() {
  const cartDrawer = getCartDrawer();
  if (!cartDrawer) return false;

  try {
    const response = await fetch(`/?sections=cart-drawer,cart-icon-bubble`);
    const sections = await response.json();

    const drawerContainer = document.getElementById("CartDrawer");
    const bubbleContainer = document.getElementById("cart-icon-bubble");

    if (drawerContainer && sections["cart-drawer"]) {
      const parsedDrawer = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");
      const newDrawer = parsedDrawer.querySelector("#CartDrawer");

      if (newDrawer) {
        drawerContainer.innerHTML = newDrawer.innerHTML;
      }
    }

    if (bubbleContainer && sections["cart-icon-bubble"]) {
      const parsedBubble = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
      const newBubble = parsedBubble.querySelector("#cart-icon-bubble");

      if (newBubble) {
        bubbleContainer.innerHTML = newBubble.innerHTML;
      }
    }

    window.updateBundleAwareCartBubble?.();

    if (typeof cartDrawer.renderContents === "function") {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      cartDrawer.renderContents({ sections, ...cartData });
    }

    if (typeof cartDrawer.open === "function") {
      cartDrawer.open();
      return true;
    }

    cartDrawer.classList.add("active");
    return true;
  } catch (error) {
    console.error("Failed to render cart drawer", error);
    return false;
  }
}

function flashButtonText(button, successText, originalText, duration = 1600) {
  if (!button) return;

  const previousDisabled = button.disabled;
  button.disabled = true;
  button.textContent = successText;
  button.classList.add("is-success");

  window.setTimeout(() => {
    button.textContent = originalText;
    button.classList.remove("is-success");
    button.disabled = previousDisabled;
  }, duration);
}


function bindAddToCart() {
  const handleAddBundleToCart = async () => {
    const allComplete = state.slots.every((slot) => slot.complete);
    if (!allComplete) return;

    const items = buildCartItemsFromSlots(state.slots);
    if (!items.length) return;

    setAddButtonsLoading(true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Failed to add bundle to cart');
      }

      clearSavedState();

      const drawerOpened = await renderCartDrawer();
      if (!drawerOpened) {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error('Failed to add bundle to cart', error);
    } finally {
      setAddButtonsLoading(false);
      renderSummary();
    }
  };

  addButton?.addEventListener('click', handleAddBundleToCart);
  addButtonMobile?.addEventListener('click', handleAddBundleToCart);
}




    function bindSizeSlider() {
      if (!sizeSlider) return;

      sizeSlider.addEventListener("input", () => {
        const nextSize = Number(sizeSlider.value || 3);
        state.bundleSize = nextSize;
        state.discountPercent = getDiscountPercent(nextSize);

        resizeSlots(nextSize);
        commitUI();
      });
    }

    function init() {
  const restoredFromUrl = restoreStateFromUrl();

  if (!restoredFromUrl) {
    const restoredFromStorage = loadStateFromStorage();
    if (!restoredFromStorage) {
      state.bundleSize = 3;
      state.discountPercent = getDiscountPercent(3);
      resizeSlots(3);
    }
  }

  if (sizeSlider) {
    sizeSlider.value = String(state.bundleSize);
  }

  bindSizeSlider();
  bindSummaryEvents();
  bindModalEvents();
  bindAddToCart();
  bindMobileSummaryEvents();
  bindSaveAndShare();

  commitUI();

  renderDesignModal();
  renderProductTypeModal();

  state.slots.forEach((slot, index) => {
    if (slot.productHandle && !slot.productJson) {
      hydrateSlotProduct(index);
    }
  });
}

    init();
  });
});